<template>
  <!-- 登录方式选择 -->
  <div class="loginBoxWin">
    <!-- 账号密码登录 -->
    <div class="page_win pwdLogin" v-if="selectLoginWay === 'accountLogin'">
      <div class="topContent">
        <!-- <div class="topContent_l"></div> -->
        <div class="topContent_m">
          <span>{{ $store.state.pwdLoginTitle }}</span>
        </div>
        <div class="topContent_r" @click="loginOut"  v-if="$store.state.pwdLoginTitle == '继续登录'">
          <img :src="closeImg" />
        </div>
      </div>
      <div class="bottomContent">
        <div class="view_group">
          <div class="view_group_l">
            <img :src="accountImg" class="account_icon" alt="" />
            <input
              type="text"
              name="myName"
              v-model="myName"
              placeholder="请输入账号"
              autocomplete="off"
            />
          </div>
          <div class="view_group_r" @click="myName = ''">
            <img :src="close_icon2" alt="" />
          </div>
        </div>
        <div class="view_group">
          <div class="view_group_l">
            <img :src="passImg" class="pwd_icon" alt="" />
            <input
              class="codeInput"
              maxlength="20"
              type="password"
              name="myPass"
              v-model="myPass"
              placeholder="请输入密码"
              autocomplete="off"
              secureTextEntry="NO"
            />
          </div>
          <div
            class="view_group_r forgetPass"
            @click="toFindPwd"
            v-if="$store.state.pwdLoginTitle != '继续登录'"
          >
            忘记密码?
          </div>
        </div>
      </div>
      <div class="register" v-if="$store.state.pwdLoginTitle != '继续登录'">
        <div class="" @click="selectLoginWay = 'phoneLogin'">手机登录</div>
        <div class="" @click="toRegister">账号注册</div>
        <div class="" @click="freeLogin">游客登录</div>
      </div>
      <div class="bot_btn" @click="userPassLogin">立即登录</div>
      <div
        class="bot_btn"
        @click="loginOut"
        v-if="$store.state.pwdLoginTitle == '继续登录'"
      >
        切换账号
      </div> 
      <div class="botBox" v-if="$store.state.pwdLoginTitle != '继续登录'">
        <div class="userRule">
          <div class="userRule_l" @click="isCheched = !isCheched">
            <img :src="checkRule" alt="" v-if="isCheched" />
          </div>
          <div class="userRule_r">
            <span>&nbsp;我已阅读并同意</span
            ><a
              @click="
                isShowAgreement = true;
                ruleType = 'agr';
              "
              >用户协议</a
            ><span>及</span
            ><a
              @click="
                isShowAgreement = true;
                ruleType = 'pri';
              "
              >隐私政策</a
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 手机号登录 -->
    <div class="page_win phoneLogin" v-if="selectLoginWay === 'phoneLogin'">
      <div class="topContent">
        <div class="topContent_m">
          <span>手机登录</span>
        </div>
      </div>
      <div class="bottomContent">
        <div class="view_group">
          <div class="view_group_l">
            <img :src="phoneImg" class="phone_icon" alt="" />
            <input
              onkeyup="this.value=this.value.replace(/\D/g,'')"
              onafterpaste="this.value=this.value.replace(/\D/g,'')"
              type="text"
              maxlength="11"
              name="mobile"
              v-model="mobile"
              autocomplete="off"
              placeholder="请输入手机号码"
            />
          </div>
          <div class="view_group_r" @click="mobile = ''">
            <img :src="close_icon2" alt="" />
          </div>
        </div>
        <div class="view_group">
          <div class="view_group_l">
            <img :src="passImg" class="pwd_icon" alt="" />
            <input
              class="codeInput"
              maxlength="6"
              type="text"
              name="code"
              v-model="code"
              autocomplete="off"
              placeholder="请输入验证码"
            />
          </div>
          <div
            class="view_group_r getcodeAll"
            @click="getCode"
            :disabled="countdown < 60 && countdown >= 1"
          >
            {{
              countdown < 60 && countdown >= 1
                ? `${countdown}秒后可重发`
                : "获取验证码"
            }}
          </div>
        </div>
      </div>

      <div class="register">
        <div class="" @click="selectLoginWay = 'accountLogin'">密码登录</div>
        <div class="" @click="toRegister">账号注册</div>
        <div class="" @click="freeLogin">游客登录</div>
      </div>
      <div class="bot_btn" @click="phoneUserPhone()">立即登录</div>
      <div class="botBox">
        <div class="userRule">
          <div class="userRule_l" @click="isCheched = !isCheched">
            <img :src="checkRule" alt="" v-if="isCheched" />
          </div>
          <div class="userRule_r">
            <span>&nbsp;我已阅读并同意</span
            ><a
              @click="
                isShowAgreement = true;
                ruleType = 'agr';
              "
              >用户协议</a
            ><span>及</span
            ><a
              @click="
                isShowAgreement = true;
                ruleType = 'pri';
              "
              >隐私政策</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="tipWin" v-if="$store.state.winType.isAgreementTip">
      <agreementTip />
    </div>
    <div class="agrBox" v-if="isShowAgreement">
      <agreement class="agrCon" :type="ruleType" />
      <div
        class="closeAgr"
        @click="
          isShowAgreement = false;
          ruleType = '';
        "
      >
        <img :src="closeImg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { hex_md5 } from "@/common/js/md5";
import fun from "@/common/js/common";
import agreement from "../../components/agreement.vue";
import agreementTip from "./agreementTip";
export default {
  name: "loginBox",
  inject: ["reload"],
  components: {
    agreement,
    agreementTip,
  },
  data() {
    return {
      showInfo: "",
      adid: "",
      userInfo: "",
      myName: "",
      myPass: "",
      mobile: "",
      code: "",
      countdown: 60,
      checkRule: require("../../assets/img/view6/select.png"),
      isCheched: false,
      logo2: require("../../assets/img/view6/logo2.png"),
      closeImg: require("../../assets/img/new2/close.png"), // 关闭
      close_icon2: require("../../assets/img/view6/close2.png"),
      accountImg: require("../../assets/img/view6/account.png"),
      passImg: require("../../assets/img/view6/pwd.png"),
      codeImg: require("../../assets/img/code.png"),
      phoneImg: require("../../assets/img/view6/phone.png"), // 手机号
      loginList: [
        {
          name: "手机登录",
          value: "phoneLogin",
        },
        {
          name: "账号登录",
          value: "accountLogin",
        },
      ],
      selectLoginWay: "accountLogin",
      closeImg: require("../../assets/img/new2/close.png"), // 关闭
      isShowAgreement: false,
      ruleType: "agr",
    };
  },
  created() {},
  mounted() {
    console.log('----------------------------')
    this.userInfo =
      localStorage.getItem("userInfo") &&
      localStorage.getItem("userInfo") != "undefined"
        ? JSON.parse(localStorage.getItem("userInfo"))
        : {};
    this.adid = localStorage.getItem("adid")
      ? localStorage.getItem("adid")
      : fun.getQueryString("adid");
      if(this.$store.state.pwdLoginTitle=="继续登录" && localStorage.getItem("userLoginMsg")){
        let msg = JSON.parse(localStorage.getItem("userLoginMsg"));
        this.myName = msg.uname;
        this.myPass = msg.pwd;
      }
    console.log(localStorage.getItem("userLoginMsg"),'---------')
    //20220310
    this.showInfo = localStorage.getItem("showInfo")
      ? JSON.parse(localStorage.getItem("showInfo"))
      : {};
    if (
      this.showInfo != null &&
      this.showInfo.firstPage != null &&
      this.showInfo.firstPage != undefined
    ) {
      if (this.showInfo.firstPage == 0 || this.showInfo.firstPage == 2) {
        this.selectLoginWay = "accountLogin";
      } else {
        this.selectLoginWay = "phoneLogin";
      }
    }
  },
  methods: {
    loginOut() {
      localStorage.removeItem("userInfo");
      this.userInfo = "";
      this.$store.commit("postPwdLoginTitle", "账号登录");
    },
    toRegister() {
      this.$store.dispatch("IsLoginBoxFun", false);
      this.$store.dispatch("IsRegisterFun", true);
    },
    toFindPwd() {
      this.$store.dispatch("IsLoginBoxFun", false);
      this.$store.dispatch("IsFindPwdFun", true);
    },
    userPassLogin() {
      console.log(this.$store.state.pwdLoginTitle)
      if (!this.isCheched && this.$store.state.pwdLoginTitle !="继续登录") {
        this.$store.dispatch("IsAgreementTipFun", true);
        return false;
      } else if (!this.myName) {
        this.$toast.text("请输入用户名");
        return false;
      }

      if (!this.myPass) {
        this.$toast.text("请输入密码");
        return false;
      }

      if (this.isCommit) {
        // 说明当前有请求正在提交了，避免重复提交
        return;
      }
      // 如果没有提交，则修改提交状态, 后续的请求不可以再提交
      this.isCommit = true;

      var time = new Date().getTime();
      var sign = hex_md5(
        this.userInfo.uid ? this.userInfo.uid : "" + this.adid + time
      );
      var device_params = this.$store.state.deviceData;
      let data = {
        adid: this.adid,
        sign: sign,
        time: time,
        os: device_params.os,
        uname: this.myName,
        device_params: device_params,
        pwd: this.myPass,
        reg_type: "1", //1：用户名注册，2：随机注册，3：短信登录,0:为游客登录
      };

      this.$http.post(fun.apiUrl + "api/member/login", data).then(
        function (res) {
          // 请求完成，修改防止重复提交标识，让其他请求可以提交
          this.isCommit = false;
          if (res.body.code === 200) {
            localStorage.setItem("isOldReg", this.adid);
            this.$toast.text(res.body.msg);
            localStorage.setItem("userInfo", JSON.stringify(res.body.data));
            this.$store.dispatch("IsLoginBoxFun", false);
            if (res.body.data.fcm ==1&&this.showInfo.kfPageShow==1) {
              this.$store.dispatch("IsReconiseInfoFun", true);
              this.$store.dispatch("ReconiseInfoTypeFun", 2);
            }
            this.reload();
            /*******只登录跳转认证提示，认证页面******* */
            if (res.body.data.loginFcm == 2 && res.body.data.fcm != "1") {
              let _this = this;
              this.$store.dispatch("IsReconiseInfoFun", true);
            }
          } else {
            this.$toast.text(res.body.msg);
          }
        },
        function (res) {
          // 请求完成，修改防止重复提交标识，让其他请求可以提交
          this.isCommit = false;
        }
      );
    },
    // 游客登录
    freeLogin() {
      if (!this.isCheched) {
        this.$store.dispatch("IsAgreementTipFun", true);
        return false;
      }
      var time = new Date().getTime();
      var sign = hex_md5(
        this.userInfo.uid ? this.userInfo.uid : "" + +this.adid + time
      );
      var device_params = this.$store.state.deviceData;

      let data = {
        adid: this.adid,
        sign: sign,
        time: time,
        os: this.$store.state.deviceData.os,
        device_params: device_params,

        reg_type: "0",
      };
      this.$http.post(fun.apiUrl + "api/member/tourist", data).then(
        function (res) {
          if (res.body.code === 200) {
            let msg = {
               uname:res.body.data.uname,
                pwd: res.body.data.pwd,
            }
            localStorage.setItem("userLoginMsg",JSON.stringify(msg));
            localStorage.setItem("isOldReg", this.adid);
            this.$toast.text(res.body.msg);
            localStorage.setItem("userInfo", JSON.stringify(res.body.data));
            this.$store.dispatch("IsLoginBoxFun", false);
            this.$store.commit("postRegisterPwd", res.body.data.pwd);
            this.$store.dispatch("IsAccountAndPasFun", true);
            let _this = this;
            setTimeout(function () {
              _this.$store.dispatch("IsAccountAndPasFun", false);
              _this.reload();
            }, 5000);
          } else {
            this.$toast.text(res.body.msg);
          }
        },
        function (res) {}
      );
    },
    // 获取验证码
    getCode() {
      if (!this.mobile) {
        this.$toast.text("请输入手机号");
        return false;
      }
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.mobile)) {
        this.$toast.text("手机号码有误，请重新输入");
        return false;
      }
      // 发送验证码
      if (this.countdown < 60 && this.countdown >= 1) {
        return;
      }
      var time = new Date().getTime();
      var sign = hex_md5(
        this.userInfo.uid ? this.userInfo.uid : "" + this.adid + time
      );
      let data = {
        adid: this.adid,
        sign: sign,
        time: time,
        os: this.$store.state.deviceData.os,
        phone: this.mobile,
      };

      this.$http.post(fun.apiUrl + "api/member/code", data).then(
        function (res) {
          this.countDown();
          this.$toast.text(res.body.msg);
        },
        function (res) {}
      );
    },
    // 手机号登录
    phoneUserPhone() {
      if (!this.isCheched) {
        this.$store.dispatch("IsAgreementTipFun", true);
        return false;
      } else if (!this.mobile) {
        this.$toast.text("请输入手机号");
        return false;
      }
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.mobile)) {
        this.$toast.text("手机号码有误，请重新输入");
        return false;
      }
      if (!this.code) {
        this.$toast.text("请输入验证码");
        return false;
      }

      if (this.isCommit) {
        // 说明当前有请求正在提交了，避免重复提交
        return;
      }
      // 如果没有提交，则修改提交状态, 后续的请求不可以再提交
      this.isCommit = true;

      var time = new Date().getTime();
      var sign = hex_md5(
        this.userInfo.uid ? this.userInfo.uid : "" + +this.adid + time
      );
      var device_params = this.$store.state.deviceData;
      let data = {
        adid: this.adid,
        sign: sign,
        time: time,
        os: device_params.os,
        device_params: device_params,
        phone: this.mobile,
        code: this.code,
        reg_type: "3",
      };
      this.$http.post(fun.apiUrl + "api/member/login", data).then(
        function (res) {
          // 请求完成，修改防止重复提交标识，让其他请求可以提交
          this.isCommit = false;
          if (res.body.code === 200) {
            localStorage.setItem("isOldReg", this.adid);
            this.$toast.text(res.body.msg);
            localStorage.setItem("userInfo", JSON.stringify(res.body.data));
            this.$store.dispatch("IsLoginBoxFun", false);
            if (res.body.data.fcm ==1&&this.showInfo.kfPageShow==1) {
              this.$store.dispatch("IsReconiseInfoFun", true);
              this.$store.dispatch("ReconiseInfoTypeFun", 2);
            }
            this.reload();
            /*******只登录跳转认证提示，认证页面******* */
            if (res.body.data.loginFcm == 2 && res.body.data.fcm != "1") {
              let _this = this;
              this.$store.dispatch("IsReconiseInfoFun", true);
            }
          } else {
            this.$toast.text(res.body.msg);
          }
        },
        function (res) {
          // 请求完成，修改防止重复提交标识，让其他请求可以提交
          this.isCommit = false;
        }
      );
    },
    // 倒计时
    countDown() {
      if (this.countdown < 60 && this.countdown >= 1) {
        return;
      }

      let self = this;
      self.countdown = 60;
      self.countdown -= 1;
      if (self.clear) {
        clearInterval(self.clear);
      }
      self.clear = null;
      self.clear = setInterval((_) => {
        if (self.countdown > 0) {
          self.countdown -= 1;
        } else {
          clearInterval(self.clear);
        }
      }, 1000);
    },
  },
};
</script>

<style  lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
input:-webkit-autofill {
  transition: background-color 5000s ease-in-out 0s;
}
::-webkit-input-placeholder {
  color: #bcbcbc;
}
::-moz-placeholder {
  color: #bcbcbc;
} /* firefox 19+ */
:-ms-input-placeholder {
  color: #bcbcbc;
} /* ie */
input:-moz-placeholder {
  color: #bcbcbc;
}
.loginBoxWin {
  @include flex_box(column, none, stretch);
}

.topContent {
  height: 0.68rem;
  @include flex_box(row, space-between, stretch);
}
.topContent_l,
.topContent_m,
.topContent_r {
  @include flex_box(row, center, center);
}
.topContent_m {
  flex: 1;
  span {
    font-size: 0.38rem;
    font-weight: 600;
    letter-spacing: 2px;
    color: #ff913a;
    line-height: 0.68rem;
  }
}
.topContent_l,
.topContent_r {
  width:.68rem;
  height: 0.68rem;
  img {
    width: .3rem;
    height: auto;
  }
}
.topContent_r{
  justify-content: flex-end
}

.bottomContent {
  @include flex_box(column, none, stretch);
}
.view_group {
  position: relative;
  padding: 0 0.22rem;
  border-radius: 0.1rem;
  margin-top: 0.24rem;
  height: 0.82rem;
  @include flex_box(row, space-between, center);
  border: 1px solid #ff913a;
}

.getcodeAll,
.forgetPass {
  height: 0.46rem;
  background: #ff913a;
  color: #ffffff;
  border-radius: 0.1rem;
  font-size: 12px;
  padding: 0 0.16rem;
  @include flex_box(row, center, center);
}
.register {
  margin-top: 0.1rem;
  height: 0.5rem;
  @include flex_box(row, space-between, stretch);
  div {
    @include flex_box(row, center, center);
    flex: 1;
    font-size: 0.24rem;
    color: #ff913a;
  }
}

.botBox {
  height: 0.6rem;
  @include flex_box(row, space-between, stretch);
}
.botBox_l {
  @include flex_box(row, none, center);
  font-size: 0.22rem;
}
.userRule {
  @include flex_box(row, space-between, center);
  font-size: 14px;
}
.userRule_l {
  @include flex_box(row, center, center);
  width: 0.28rem;
  height: 0.28rem;
  background-size: 100% 100%;
  border: 1px solid #ff913a;
  border-radius: 50%;
  img {
    width: 0.2rem;
    height: auto;
  }
}
.userRule_r {
  @include flex_box(row, none, center);
  vertical-align: middle;
  line-height: 0.6rem;
  span {
    color: #a6a5ad;
  }
  a {
    text-decoration: none;
    color: #ff913a;
  }
}
.tipWin {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  @include flex_box(row, center, center);
}
.agrBox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.agrCon {
  width: 100%;
  height: 100%;
}
.closeAgr {
  position: absolute;
  right: 0;
  top: 0;
  width: 0.6rem;
  height: 0.6rem;
  @include flex_box(row, center, center);
  img {
    width: 0.3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/view8/loginBox.vue